import script from "./VitaCodeInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaCodeInput.vue?vue&type=script&setup=true&lang=ts"

import "./VitaCodeInput.vue?vue&type=style&index=0&id=3b4edca0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b4edca0"]])

export default __exports__